import React from 'react';
import { CnLayoutSection as UICnLayoutSection } from '@/components/cn-layout/index';
import { getSlotDom, getExtraDom, getExtraProps } from './util';
import './view.scss';
const CnLayoutSection = (props) => {
    const { children, _layout } = props || {};
    const { componentSlot } = _layout || {};
    const extraDom = getExtraDom(props);
    const slotDom = getSlotDom(componentSlot);
    const extraProps = getExtraProps(props);
    return (<UICnLayoutSection extra={extraDom} {...extraProps}>
      {slotDom}
      {children}
    </UICnLayoutSection>);
};
CnLayoutSection.displayName = 'CnLayoutSection';
export default CnLayoutSection;
export { CnLayoutSection };
